<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Agências</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Agências</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Banco</th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0">Agência</th>
                    <th scope="col" class="border-0">Nome</th>
                    <th scope="col" class="border-0">CNPJ</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(agency, index) in agencies" :key="index">
                    <td style="vertical-align: middle;">
                    <img v-if="agency.Banco.Code == '001'" src="@/assets/images/bank_0001.png"
                      height="32px" width="32px" class="logo" />
                    <img v-else-if="agency.Banco.Code == '033'" src="@/assets/images/bank_0033.png"
                      height="32px" width="32px" class="logo" />
                    <img v-else-if="agency.Banco.Code == '041'" src="@/assets/images/bank_0041.png"
                      height="32px" width="32px" class="logo" />
                    <img v-else-if="agency.Banco.Code == '104'" src="@/assets/images/bank_0104.png"
                      height="32px" width="32px" class="logo" />
                    <img v-else-if="agency.Banco.Code == '237'" src="@/assets/images/bank_0237.jpg"
                      height="32px" width="32px" class="logo" />
                    <img v-else-if="agency.Banco.Code == '341'" src="@/assets/images/bank_0341.png"
                      height="32px" width="32px" class="logo" />
                    <img v-else-if="agency.Banco.Code == '422'" src="@/assets/images/bank_0422.png"
                      height="32px" width="32px" class="logo" />
                    <img v-else-if="agency.Banco.Code == '745'" src="@/assets/images/bank_0745.png"
                      height="32px" width="32px" class="logo" />
                    <img v-else-if="agency.Banco.Code == '748'" src="@/assets/images/bank_0748.png"
                      height="32px" width="32px" class="logo" />
                    <img v-else src="@/assets/images/bank_default.png"
                      height="32px" width="32px" class="logo" />
                    </td>
                    <td class="text-left">{{ agency.Banco.Name }}</td>
                    <td>{{ agency.Banco.Code }}</td>
                    <td>{{ agency.Compe }}</td>
                    <td>{{ agency.Nome }}</td>
                    <td v-if="agency.CNPJ !== null">{{ agency.CNPJ | CNPJMask}}</td>
                    <td v-else>N/A</td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button v-if="agency.EhInsercaoManual"
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            v-if="$isAuthorize('Agencia', 'Atualizar')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenAgency($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('Agencia', 'Excluir')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="ConfirmDeleteAgency(agency.Nome, agency.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="agencies == undefined || agencies == null || agencies.length == 0">
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal size="sm" id="mFormAgency" :title="modalTitle" :no-close-on-backdrop="true" :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Banco -->
        <ValidationObserver tag="form" ref="validatedAgencyForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Banco</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="infoAgency.Banco.Id"
                  :class="validatedAgencyForm | showValidateError(invalid)"
                  :value="null"
                  :disabled="isSeeing"
                >
                    <option :value="null" selected>Selecione</option>
                    <option
                      v-for="bank in banks"
                      v-bind:key="bank.Id"
                      v-bind:value="bank.Id"
                    >
                    {{ bank.Code + " - " + bank.Name }}
                  </option> 
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedAgencyForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Agência -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Agência</label>
              <ValidationProvider rules="required|min:5|max:5" v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  v-model="infoAgency.Compe"
                  :class="validatedAgencyForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedAgencyForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Nome -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Nome</label>
              <ValidationProvider rules="required|max:255" v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  v-model="infoAgency.Nome"
                  :class="validatedAgencyForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedAgencyForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- CNPJ -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>CNPJ</label>
              <ValidationProvider rules="min:14" v-slot="{ errors, invalid }">
                <the-mask class="form-control"
                  :class="validatedAgencyForm | showValidateError(invalid)"
                  type="tel"
                  :mask="['##.###.###/####-##']"
                  v-model="infoAgency.CNPJ"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedAgencyForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveAgency()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="12" class="form-group">
                <d-select
                  v-model="filter.CodigoBanco"
                  :value="null"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Banco</option>
                  <option
                    v-for="bank in banks"
                    v-bind:key="bank.Id"
                    v-bind:value="bank.Id"
                  >
                  {{ bank.Code + " - " + bank.Name }}
                </option> 
              </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <input placeholder="Nome da Agência" type="text" class="form-control" v-model="filter.NomeAgencia" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <input placeholder="Código da Agência" type="text" class="form-control" :maxlength="5" v-model="filter.CodigoAgencia" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            placeholder="CNPJ"
            class="form-control"
            type="tel"
            :mask="['##.###.###/####-##']"
            v-model="filter.CNPJ"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Agencia', 'Adicionar')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova Agência"
      v-on:click="OpenAgency($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import dateField from "../common/date-field";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "agencies",
  data: function() {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      modalTitle: "Nova Agência",
      countFilter: 0,
      filter: {
        CodigoBanco: null,
        NomeBanco: null,
        CodigoAgencia: null,
        NomeAgencia: null,
        CNPJ: null
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      idBank: 0,
      pOpened: null,
      banks: [],
      agencies: [],
      infoAgency: {
        Compe: null,
        CNPJ: null,
        Nome: null,
        EhHabilitado: null,
        EhInsercaoManual: null,
        Banco: {
          Id: null,
          Code: null,
          ISPB: null,
          Name: null
        }
      },
      isSeeing: false,
      validatedAgencyForm: false,
      window: {
        width: 0,
        height: 0
      },
    };
  },
  filters: {
    CNPJMask (value) {
      if (!value) return ''
      
      const cnpj = value.toString().replace(/\D/g, '')
      if (cnpj.length === 14) {
        return `${cnpj.substr(0, 2)}.${cnpj.substr(2, 3)}.${cnpj.substr(5, 3)}/${cnpj.substr(8, 4)}-${cnpj.substr(12)}`
      } else if (cnpj.length === 11) {
        return `${cnpj.substr(0, 3)}.${cnpj.substr(3, 3)}.${cnpj.substr(6, 3)}-${cnpj.substr(9)}`
      } else {
        return value
      }
    }
  },
  components: {
    dateField
  },
  watch: {
    "pagination.PageNumber": function() {
      this.AgencyList();
    },
    "pagination.RowsPerPage": function() {
      this.AgencyList();
    }
  },
  mounted() {
    this.AgencyList();
  },
  methods: {
    OpenAgency: function(e, i, view) {
      e.preventDefault();
      this.BankList();
      this.validatedAgencyForm = false;
      this.ResetInfoAgency();
      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.isSeeing = false;
        this.modalTitle = "Editar Agência";
        this.infoAgency = Object.assign({}, this.agencies[i]);
      } else {
        // Add new
        this.pOpened = null;
        this.ResetInfoAgency;
        this.isSeeing = false;
        this.modalTitle = "Nova Agência";
        this.ResetInfoAgency();
      }
      this.$bvModal.show("mFormAgency");
    },
    OpenModalFilter: function() {
      this.BankList();
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.AgencyList();
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Code: null,
        ISPB: null
      };
      this.AgencyList();
    },
    ResetInfoAgency: function() {
      this.infoAgency = {
        Compe: null,
        CNPJ: null,
        Nome: null,
        EhHabilitado: null,
        EhInsercaoManual: null,
        Banco: {
          Id: null,
          Code: null,
          ISPB: null,
          Name: null
        }
      };
    },
    SaveAgency: function() {
      this.validatedAgencyForm = true;

      this.$refs.validatedAgencyForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            
            this.infoAgency.EhHabilitado = true;
            this.infoAgency.EhInsercaoManual = true;

            this.$store.dispatch("AddAgency", this.infoAgency)
              .then(() => {
                this.$makeToast("A Agência foi cadastrado com sucesso.", "success", "Agência cadastrado");
                this.AgencyList();
                this.$bvModal.hide("mFormAgency");
              })
              .catch(error => {
                this.$makeToast(undefined, "danger", "Erro ao cadastrar a Agência", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store.dispatch("UpdateAgency", this.infoAgency)
              .then(() => {
                this.$makeToast("A Agência foi atualizado com sucesso.", "success", "Agência atualizada");
                this.AgencyList();
                this.$bvModal.hide("mFormAgency");
              })
              .catch(error => {
                this.$makeToast(undefined, "danger", "Erro ao atualizar a Agência", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetParamsAgency(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.CodigoBanco": this.filter.CodigoBanco,
        "Object.NomeBanco": this.filter.NomeBanco,
        "Object.Compe": this.filter.CodigoAgencia,
        "Object.Nome": this.filter.NomeAgencia,
        "Object.CNPJ": this.filter.CNPJ
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    AgencyList: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.CodigoBanco)) this.countFilter++;
      if (hasValue(this.filter.NomeBanco)) this.countFilter++;
      if (hasValue(this.filter.CodigoAgencia)) this.countFilter++;
      if (hasValue(this.filter.NomeAgencia)) this.countFilter++;
      if (hasValue(this.filter.CNPJ)) this.countFilter++;
      this.loadingList = true;
      const data = this.GetParamsAgency();
      this.$store.dispatch("AgencyList", { params: data })
        .then(response => {
          this.agencies = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar as Agências", error);
        })
        .finally(() => (this.loadingList = false));
    },
    BankList: function() {
      this.loadingList = true;
      const data = this.GetParamsAgency();
      data.PageNumber = null;
      data.RowsPerPage = null;
      this.$store.dispatch("BankList", { params: data })
        .then(response => {
          this.banks = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar os Bancos", error);
        })
        .finally(() => (this.loadingList = false));
    },
    ConfirmDeleteAgency: function(description, id) {
      this.$makeMsgBox("Você tem certeza que deseja remover " + description + " ?", "Confirmar", this.DeleteAgency, id);
    },
    DeleteAgency: function(id) {
      this.loadingList = true;
      this.$store.dispatch("DeleteAgency", { id: id })
        .then(() => {
          this.$makeToast("A Agência foi removida com sucesso.", "success", "Agência removido");
          this.AgencyList();
          this.$bvModal.hide("mFormAgency");
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao remover a Agência", error);
        })
        .finally(() => (this.loadingList = false));
    },
  }
};
</script>

<style>
.custom-select.is-invalid {
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right .75rem center/8px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/agencies.vue